import { Detail, DetailContent, DetailFooter, DetailHeader, DetailHeading } from './Detail'
import { DetailSkeleton } from './DetailSkeleton'
import { Item, ItemCheckbox, Items, List, ListFooter, ListHeader, ListHeading } from './List'
import { SplitListRoot } from './SplitListRoot'

export type { SplitListProps } from './context'
export type { SplitListItemCheckboxProps, SplitListItemProps } from './List'
/** Read split-list selection state from detail content (e.g. selected index, mobile drawer). */
export { useSplitListContext } from './context'
/**
 * SplitList
 *
 * A list of form sections to jump to each section more easily by clicking on the section on
 * the sidebar menu list item. This component is good to use for very long forms.
 *
 * This is a parent wrapper component accepting StackProps.
 *
 * See: /docs/design-system/modules/lists/split-list/split-list
 *
 * @agent-gotcha Master-detail presentation. Render INSIDE ListLayout's ContentArea for filtered/sorted/paginated pages.
 * @agent-gotcha Composes: SplitList.List + SplitList.ListHeader + SplitList.ListHeading + SplitList.Items + SplitList.Item + SplitList.ListFooter (list side); SplitList.Detail + SplitList.DetailHeader + SplitList.DetailHeading + SplitList.DetailContent (detail side).
 * @agent-gotcha Standalone only for embedded surfaces (tabs/drawers).
 */
export const SplitList = Object.assign(SplitListRoot, {
  List,
  ListHeader,
  ListHeading,
  ListFooter,
  Items,
  Item,
  ItemCheckbox,
  Detail,
  DetailHeader,
  DetailHeading,
  DetailContent,
  DetailFooter,
  DetailSkeleton
})
